module.exports = __webpack_public_path__ + "img/capacity-04.2ac597d7.png";